import { action, mutatorAction } from 'satcheljs';
import type { OwsOptionsFeatureType } from '../store/schema/OwsOptionsFeatureType';
import type OwsOptionsBase from '../store/schema/OwsOptionsBase';
import type OwsOptionsStore from '../store/schema/OwsOptionsStore';
import type { MailboxInfo } from 'owa-client-types';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { getOwsOptionsStore } from '../selectors/getOwsOptionsStore';

export interface SetOptionValueActionMessage {
    feature: OwsOptionsFeatureType;
    value: OwsOptionsBase;
    mailboxInfo: MailboxInfo;
}
export const setOptionValue: (
    feature: OwsOptionsFeatureType,
    value: OwsOptionsBase,
    mailboxInfo?: MailboxInfo
) => SetOptionValueActionMessage = action(
    'setOptionValue',
    (
        feature: OwsOptionsFeatureType,
        value: OwsOptionsBase,
        mailboxInfo: MailboxInfo = getGlobalSettingsAccountMailboxInfo()
    ): SetOptionValueActionMessage => ({
        feature,
        value,
        mailboxInfo,
    })
);

export interface InitializeOptionValuesActionMessage {
    potentialOptionValues: any[];
    mailboxInfo: MailboxInfo;
}
export const initializeOptionValues: (
    potentialOptionValues: any[],
    mailboxInfo?: MailboxInfo
) => InitializeOptionValuesActionMessage = action(
    'initializeOptionValues',
    (
        potentialOptionValues: any[],
        mailboxInfo: MailboxInfo = getGlobalSettingsAccountMailboxInfo()
    ): InitializeOptionValuesActionMessage => ({
        potentialOptionValues,
        mailboxInfo,
    })
);

export interface SetExtendedOptionValueActionMessage {
    feature: OwsOptionsFeatureType;
    value: Partial<OwsOptionsBase>;
    mailboxInfo: MailboxInfo;
}
export const setExtendedOptionValue: (
    feature: OwsOptionsFeatureType,
    value: Partial<OwsOptionsBase>,
    mailboxInfo?: MailboxInfo
) => SetExtendedOptionValueActionMessage = action(
    'setExtendedOptionValue',
    (
        feature: OwsOptionsFeatureType,
        value: Partial<OwsOptionsBase>,
        mailboxInfo: MailboxInfo = getGlobalSettingsAccountMailboxInfo()
    ): SetExtendedOptionValueActionMessage => ({
        feature,
        value,
        mailboxInfo,
    })
);

export interface SetServiceOptionStoreDataActionMessage {
    storeData: { [key: string]: OwsOptionsStore };
}
export const setServiceOptionStoreData: (storeData: {
    [key: string]: OwsOptionsStore;
}) => SetServiceOptionStoreDataActionMessage = action(
    'setServiceOptionStoreData',
    (storeData: { [key: string]: OwsOptionsStore }): SetServiceOptionStoreDataActionMessage => ({
        storeData,
    })
);

export interface FeatureValue {
    feature: OwsOptionsFeatureType;
    value: OwsOptionsBase;
}

export const setOptionValuesMutator: (options: FeatureValue[], mailboxInfo?: MailboxInfo) => void =
    mutatorAction(
        'setOptionValues',
        (
            options: FeatureValue[],
            mailboxInfo: MailboxInfo = getGlobalSettingsAccountMailboxInfo()
        ): void => {
            const store = getOwsOptionsStore(mailboxInfo);
            for (const option of options) {
                store.options[option.feature] = option.value;
            }
        }
    );
